import { gql } from "apollo-boost";

export const SIGNIN_MUTATION = gql`
  mutation SignupMutation($email: String!, $password: String!) {
    signInUser(email: $email, password: $password) {
      token
      user {
        id
      }
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation {
    changePassword {
      user {
        id
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation {
    deleteUser {
      isSuccess
    }
  }
`;

export const SEND_CERTIFICATE = gql`
  mutation sendCertificate($certificateId: ID!) {
    sendCertificate(certificateId: $certificateId) {
      user {
        id
      }
    }
  }
`;

export const FINISH_SECTION = gql`
  mutation finishSection($userId: ID!, $sectionId: ID!) {
    finishSection(userId: $userId, sectionId: $sectionId) {
      userHistory {
        credits
      }
    }
  }
`;

export const REGISTER_CONTEST = gql`
  mutation registerContest {
    registerContest {
      user {
        id
      }
    }
  }
`;

export const FINISH_QUESTIONNAIRE = gql`
  mutation finishQuestionnaire($userId: ID!, $answers: String!) {
    finishQuestionnaire(userId: $userId, answers: $answers) {
      result
    }
  }
`;

export const SUBMIT_CODE = gql`
  mutation submitRegistrationCode($registrationCode: String!) {
    submitRegistrationCode(registrationCode: $registrationCode) {
      pharmacy {
        id
        name
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation createUser(
    $gender: String!
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $pharmacyId: ID!
    $professionId: ID!
  ) {
    createUser(
      gender: $gender
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      pharmacyId: $pharmacyId
      professionId: $professionId
    ) {
      user {
        id
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: ID!
    $firstName: String
    $lastName: String
    $email: String
    $professionId: ID
  ) {
    updateUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      email: $email
      professionId: $professionId
    ) {
      user {
        id
      }
    }
  }
`;

export const BUY_COUPON = gql`
  mutation buyCoupon($campaignId: ID!, $promotionCode: String) {
    buyCoupon(campaignId: $campaignId, promotionCode: $promotionCode) {
      isSuccess
      couponCode
      error
    }
  }
`;

export const SEND_KYTE_TEC_INVITE = gql`
  mutation sendKyteTecInvite($emailAddress: String!) {
    sendKyteTecInvite(emailAddress: $emailAddress) {
      isSuccess
    }
  }
`;

export const SEND_BARCODE = gql`
  mutation sendBarcode($emailAddress: String!, $data: String!) {
    sendBarcode(emailAddress: $emailAddress, data: $data) {
      isSuccess
    }
  }
`;

export const CREATE_DEVICE_TOKEN = gql`
  mutation createDeviceToken($token: String!) {
    createDeviceToken(token: $token) {
      deviceToken {
        id
        token
        user {
          id
        }
      }
    }
  }
`;

export const ANSWER_QUESTION = gql`
  mutation answerQuestion($questionId: String!, $answers: String!) {
    answerQuestion(questionId: $questionId, answers: $answers) {
      result
    }
  }
`;

export const FINISH_SURVEY_QUESTIONNAIRE = gql`
  mutation finishQuestionnaire($questionnaireId: ID!){
    finishQuestionnaire(questionnaireId:$questionnaireId){
      result
    }
  }
`;

export const SEND_PHARMACY_PROJECT_REQUEST = gql`
  mutation sendPharmacyProjectRequest($projectIds: [ID!]!, $message: String!){
    sendPharmacyProjectRequest(projectIds: $projectIds, message: $message){
      pharmacyProjects{
        project{
        id
        name
      }
      requestSend
      }
    }
  }
`;

export const SEND_TRAINER_MESSAGE = gql`
  mutation sendTrainerMessage($trainerId: ID!, $subject: String!, $message: String!){
    sendTrainerMessage(trainerId: $trainerId, subject: $subject, message: $message){
      user {
        id
      }
    }
  }
`;

export const SEND_TRAINER_APPOINTMENT = gql`
  mutation sendTrainerAppointment($trainerId: ID!, $date: ISO8601DateTime!, $message: String!){
    sendTrainerAppointment(trainerId: $trainerId, date: $date, message: $message){
      user {
        id
      }
    }
  }
`;

export const LIKE_NEWS_ENTRY = gql`
  mutation LikeNewsEntry($entryId: ID!){
    likeNewsEntry(entryId: $entryId){
	    newsEntry {
	      titel
	      id
	      articleId
	      publishedAt
	      excerpt
	      url
	      logoUrl
	      liked
	    }
    }
  }
`;

export const ACCEPT_GENERAL_TERMS = gql`
  mutation AcceptGeneralTerms($accepted: Boolean!) {
    acceptGeneralTerms(accepted:$accepted){
      user{
        id
      }
    }
  }
`;

export const ACCEPT_PRIVACY = gql`
  mutation AcceptPrivacy($accepted: Boolean!) {
    acceptPrivacy(accepted:$accepted){
      user{
        id
      }
    }
  }
`;

export const REQUEST_PHARMACY_CHANGE = gql`
  mutation RequestPharmacyChange($pharmacyId: ID!, $startDate: ISO8601Date!){
    requestPharmacyChange(pharmacyId: $pharmacyId, startDate: $startDate){
      user{
        id
      }
    }
  }
`;

export const SUBMIT_USER_GIVEAWAY = gql`
  mutation SubmitUserGiveaway($giveawayId: ID!, $images: [Upload!]!) {
    submitUserGiveaway(giveawayId: $giveawayId, images: $images) {
      userGiveaway {
        id
      }
    }
  }
`;